package one.healthium.data.paywall.storage

import co.touchlab.kermit.Logger
import kotlinx.serialization.json.Json
import one.healthium.data.paywall.PaywallStorage
import one.healthium.data.paywall.dto.PaywallContainerDto
import one.healthium.domain.paywall.models.Paywall
import one.healthium.domain.paywall.models.PaywallSet
import one.primehealth.app.BaseAppResourceProvider

class LocalPaywallStorage(
    private val json: Json,
    private val appResourceProvider: BaseAppResourceProvider
) : PaywallStorage {
    override suspend fun getPaywall(id: String): Paywall? {
        return try {
            val bytes = appResourceProvider.readBytes("files/paywall/paywall_$id.json")
            json.decodeFromString<PaywallContainerDto>(bytes.decodeToString()).paywall
        } catch (e: Exception) {
            Logger.e("LocalPaywallStorage", e)
            null
        }
    }

    override suspend fun getPaywallSet(id: String): PaywallSet? {
        return try {
            val bytes = appResourceProvider.readBytes("files/paywall_set/set_$id.json")
            json.decodeFromString<PaywallSet>(bytes.decodeToString())
        } catch (e: Exception) {
            Logger.e("LocalPaywallStorage", e)
            null
        }
    }
}